<div class="triangle-container">
  <svg viewBox="0 0 100 100" class="triangle-svg">
    <defs>
      <linearGradient id="grad1" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" [attr.stop-color]="awarenessColor" stop-opacity="1" />
        <stop
          offset="100%"
          [attr.stop-color]="awarenessColor"
          stop-opacity="0.80"
        />
      </linearGradient>
      <linearGradient id="grad2" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" [attr.stop-color]="considerationColor" stop-opacity="1" />
        <stop
          offset="100%"
          [attr.stop-color]="considerationColor"
          stop-opacity="0.80"
        />
      </linearGradient>
      <linearGradient id="grad3" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" [attr.stop-color]="conversionColor" stop-opacity="1" />
        <stop
          offset="100%"
          [attr.stop-color]="conversionColor"
          stop-opacity="0.80"
        />
      </linearGradient>
    </defs>

    <polygon
      points="0,0 100,0 83.333,33.333 16.667,33.333"
      [attr.fill]="
        tdspCommonService.hasKPI(kpis, 'awareness') ? 'url(#grad1)' : '#e0e0e0'
      "
      [attr.stroke]="
        tdspCommonService.hasKPI(kpis, 'awareness') ? '' : '#e0e0e0'
      "
      [attr.stroke-width]="
        tdspCommonService.hasKPI(kpis, 'awareness') ? '' : '1'
      "
    ></polygon>

    <polygon
      points="16.667,33.333 83.333,33.333 66.667,66.667 33.333,66.667"
      [attr.fill]="
        tdspCommonService.hasKPI(kpis, 'consideration')
          ? 'url(#grad2)'
          : '#e0e0e0'
      "
      [attr.stroke]="
        tdspCommonService.hasKPI(kpis, 'consideration') ? '' : '#e0e0e0'
      "
      [attr.stroke-width]="
        tdspCommonService.hasKPI(kpis, 'consideration') ? '' : '1'
      "
    ></polygon>

    <polygon
      points="33.333,66.667 66.667,66.667 50,100"
      [attr.fill]="
        tdspCommonService.hasKPI(kpis, 'conversion') ? 'url(#grad3)' : '#e0e0e0'
      "
      [attr.stroke]="
        tdspCommonService.hasKPI(kpis, 'conversion') ? '' : '#e0e0e0'
      "
      [attr.stroke-width]="
        tdspCommonService.hasKPI(kpis, 'conversion') ? '' : '1'
      "
    ></polygon>

    <text
      x="50"
      y="15"
      text-anchor="middle"
      [ngClass]="{
        'white-color': tdspCommonService.hasKPI(kpis, 'awareness'),
        label: true
      }"
    >
      Awareness
    </text>
    <text
      x="50"
      y="50"
      text-anchor="middle"
      [ngClass]="{
        'white-color': tdspCommonService.hasKPI(kpis, 'consideration'),
        label: true
      }"
    >
      Consideration
    </text>

    <text
      x="50"
      y="75"
      [ngClass]="{
        'white-color': tdspCommonService.hasKPI(kpis, 'conversion'),
        label: true
      }"
      text-anchor="middle"
    >
      Conversion
    </text>
  </svg>
</div>
